import socket from './socket';

/* Actions */

const rebootSystem = (headers) => socket.post(`/system/reboot`, undefined, headers);

export default {
  rebootSystem,
};
